import { login } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { clearLoginInfo } from '@/utils'

const user = {
  state: {
    userId:0,
    partnerId:0,
    partnerType:0,
    partnerName:'',
    partnerIcon:'',
    token: getToken(),
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER_ID: (state, id) => {
      state.userId = id
      localStorage.setItem('userId', id)
    },
    SET_PARTNER_ID: (state, partnerId) => {
        state.partnerId = partnerId
        localStorage.setItem('partnerId', partnerId)
      },
    SET_PARTNER_TYPE: (state, partnerType) => {
      state.partnerType = partnerType
      localStorage.setItem('partnerType', partnerType)
    },
    SET_PARTNER_NAME: (state, partnerName) => {
      state.partnerName = partnerName
      localStorage.setItem('partnerName', partnerName)
    },
    SET_PARTNER_ICON: (state, partnerIcon) => {
      state.partnerIcon = partnerIcon
      localStorage.setItem('partnerIcon', partnerIcon)
    },
  },

  actions: {
    // 用户名登录
    Login({ commit }, params) {
      return new Promise((resolve, reject) => {
        clearLoginInfo()
        login(params).then(res => {
           commit('SET_TOKEN', res.data.tokenValue)
           setToken(res.data.tokenValue)
           resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        setToken('')
        commit('SET_TOKEN', '')
        commit('SET_PARTNER_ID', 0)
        commit('SET_PARTNER_TYPE', '')
        commit('SET_PARTNER_NAME', '')
        commit('SET_PARTNER_ICON', '')
        resolve()
      })
    },

  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js